// @flow
import * as React from 'react';
import { Box, Text } from 'grommet';
import { CheckBox as GrommetCheckbox } from 'grommet/components/CheckBox/CheckBox';
import { FormattedMessage } from 'react-intl';


type Props = {
    value: boolean,
    onChange: Function,
    disable: boolean,
};

const PipeEitExport = (props: Props) => {
    const { value, onChange, disable } = props;

    return (
        <Box flex={false} margin={{ vertical: 'small' }}>
            <GrommetCheckbox
                name="pipe-export-name"
                checked={value}
                onChange={onChange}
                label={(
                    <Text>
                        <FormattedMessage id="pipe-export" defaultMessage="Export" />
                    </Text>
                )}
                disabled={disable}
            />
        </Box>
    );
};

export default PipeEitExport;
